const handleImageError = (event) => {
  event.target.src = "/avatar1.png";
};

export default handleImageError;